import zipCodeForm from './zip-code-form'

export default {
  zipCodeForm
}
